// angular
import { Component, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgClass } from '@angular/common';
// components
import { CardPropertySkeletonComponent } from '../../card-property/card-property-skeleton/card-property-skeleton.component';

@Component({
  selector: 'pwj-product-card-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, CardPropertySkeletonComponent, NgClass],
  templateUrl: './product-card-skeleton.component.html',
  styleUrl: './product-card-skeleton.component.scss',
  host: {
    '[class.product-card-skeleton-host--compact]': 'compact()',
    '[class.product-card-skeleton-host--list]': 'wrapInListItem()',
  },
})
export class ProductCardSkeletonComponent {
  // inputs
  count = input<number>(1);
  compact = input<boolean>(false);
  wrapInListItem = input<boolean>(false);
  containerClasses = input<string>('');

  public counter(i: number) {
    return new Array(i);
  }
}
